import { isEmpty, isObject, omit, pick } from 'lodash';

import { EXPORT_COLUMNS_ASSETS } from '@/constants/exportcolumns.constants';
import type { GenericObject } from '@/types/common';

import { KEY_MAPS } from '../VulnerabilityManagement/VulnerabilityManagement.constants';
import { EMPTY_SCORE_PARTS } from './Assets.constants';
import type { AssetTagRelationshipDTO } from './Assets.types';

export const extractTagNames = (
  tags: AssetTagRelationshipDTO[] = []
): string[] => {
  return tags.map((tag) => tag.tag_name);
};

export const findTagByName = (
  tagName: string,
  tags: AssetTagRelationshipDTO[] = []
): AssetTagRelationshipDTO | undefined => {
  return tags.find((tag) => tag.tag_name === tagName);
};

export const mapAssetCsvData = (data: GenericObject[]) => {
  const exportData = data.map((item) => {
    // pick only the keys that are in EXPORT_COLUMNS_ASSETS
    const newItem = pick(item, Object.keys(EXPORT_COLUMNS_ASSETS));

    // flatten data provider array values to a comma-separated string
    newItem.data_provider = ((newItem.data_provider as []) || []).join(', ');
    newItem.has_agent = ((newItem.has_agent as []) || []).join(', ');

    // TODO: enable when name mapping on the backend is supported
    // convert the keys to user friendly names based on EXPORT_COLUMNS_ASSETS
    // newItem = mapKeys(
    //   newItem,
    //   (_value, key) =>
    //     EXPORT_COLUMNS_ASSETS[key as keyof typeof EXPORT_COLUMNS_ASSETS] || key
    // );

    return newItem;
  });

  return exportData;
};

export const renameShieldKeys = (data: Record<string, unknown>) => {
  const renamedData: Record<string, unknown> = {};
  Object.entries(data).forEach(([key, value]) => {
    const renamedKey = KEY_MAPS[key] ?? key;
    if (isObject(value) && !Array.isArray(value)) {
      renamedData[renamedKey] = renameShieldKeys(
        value as Record<string, unknown>
      );
    } else if (key.toLowerCase().includes('shield')) {
      renamedData[renamedKey] = value;
    } else {
      renamedData[key] = value;
    }
  });
  return renamedData;
};

export const scorePartsNoTotal = (riskScoreDetails: {
  [key: string]: number;
}) => {
  const scoreParts = isEmpty(riskScoreDetails)
    ? EMPTY_SCORE_PARTS
    : riskScoreDetails;
  return omit(scoreParts, ['rtot_raw']);
};
